import { createSafeContext } from '@mews/framework';
import { CommonRepositoryParams } from '../createRegistry';

interface GraphqlClientConfigProps {
    commonRepositoryParams: () => CommonRepositoryParams;
}

const { GraphqlClientConfigContextProvider, useGraphqlClientConfigContext } = createSafeContext<
    'GraphqlClientConfigContext',
    GraphqlClientConfigProps
>('GraphqlClientConfigContext');

export const createGraphqlClientConfigContextProvider =
    <P,>(graphqlClientConfigOptions: GraphqlClientConfigProps) =>
    (props: P) => <GraphqlClientConfigContextProvider value={graphqlClientConfigOptions} {...props} />;

export const useGraphqlClientConfig = useGraphqlClientConfigContext;
